module.exports = __webpack_public_path__ + "img/Dantam Fashion 07.f6bb9a85.jpg";